import React from "react";
import Spinner from "../Spinner";
import { css } from "@linaria/core";

const Loading = () => (
  <div className={loading}>
    <Spinner className={loadingSpinner} />
  </div>
);

const loading = css`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 64px;
`;

const loadingSpinner = css`
  max-width: 56px;
  max-height: 56px;
`;

export default Loading;
